import React from 'react';
import classNames from 'classnames';

const LeaderboardCellTitleRound = (
    {
        type,
        sortingHandler,
        processingState
    }
) => {
    const isActive = processingState.sortingType === type;
    const stateCss = classNames({
        'is-active': isActive,
        'is-top': isActive && processingState.isSortingAscending
    });

    return (
        <div
            className={`leaderboard__cell leaderboard__cell--title leaderboard__cell--today ${stateCss}`}>
            <button
                className="leaderboard__cell-content-title"
                type="button"
                onClick={() => sortingHandler(type)}
            >
                <div className="leaderboard__cell-title">Round</div>
                <div className="leaderboard__cell-title-icon-wrapper">
                    <svg className="leaderboard__cell-title-icon icon" width="9" height="6" focusable="false">
                        <use xlinkHref="#icon-triangle"></use>
                    </svg>
                </div>
            </button>
            <div className="leaderboard__cell-title-m">Round</div>
        </div>
    );
};

export default LeaderboardCellTitleRound;
